import React from 'react';
import { useAuth } from '../hooks/useAuth';

const LoginPage: React.FC = () => {
  const { login, loginWithEntra, authMode, loading, error, isAuthenticated } = useAuth();
  const [username, setUsername] = React.useState('');
  const [password, setPassword] = React.useState('');

  React.useEffect(() => {
    if (isAuthenticated) {
      window.location.href = '/';
    }
  }, [isAuthenticated]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await login(username, password);
      // Redirect to home
      window.location.href = '/';
    } catch {
      // Error is displayed via context
    }
  };

  const handleEntraLogin = async () => {
    try {
      await loginWithEntra();
    } catch (err) {
      console.error('Entra login error:', err);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <h1>TCG Inventory Management</h1>
        {(authMode === 'local' || authMode === 'hybrid') && (
          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="username">Username</label>
              <input
                id="username"
                type="text"
                autoComplete="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <button type="submit" disabled={loading} className="btn-primary">
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>
        )}

        {(authMode === 'entra' || authMode === 'hybrid') && (
          <button type="button" onClick={handleEntraLogin} disabled={loading} className="btn-primary">
            {loading ? 'Connecting...' : 'Sign in with Entra'}
          </button>
        )}

        {error && <div className="error-message">{error}</div>}
      </div>
    </div>
  );
};

export { LoginPage };
